import Comissao from './Comissao';

export default Comissao;